import * as React from 'react'
import MUIPaper from '@mui/material/Paper'

const Paper = (props) => <MUIPaper {...props} />

export default Paper
